import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { EventService } from '../../../../../app/shared/API-Service/services/event.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { Image } from '../../../../../images/images'
@Component({
  selector: 'app-view-event',
  templateUrl: './view-event.component.html',
  styleUrls: ['./view-event.component.css']
})
export class ViewEventComponent implements OnInit {
  Events:object [] = [];
  img : string = Image;
  constructor(private _EventService:EventService, private _Router:Router) { }

  ngOnInit(): void {
    this.getevents();
  }
  getevents(){
    this._EventService.GetEvent().subscribe((res) => {
      this.Events = res.data
    console.log(this.Events);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  update(data){
    this._EventService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertEvent']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._EventService.DeleteEvent(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getevents();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
